import React, { Fragment, Component } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import BaseButton from "../Button/BaseButton";
import BaseAnchor from "../Anchor/BaseAnchor";

import "./sidebar.scss";

class Sidebar extends Component {
  constructor(props) {
    super(props);
    this.handleOnEscape = this.handleOnEscape.bind(this);
  }

  componentDidMount() {
    document.addEventListener("keydown", this.handleOnEscape, false);
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this.handleOnEscape);
  }

  handleOnEscape(e) {
    const { closeMenu } = this.props;
    if (e.keyCode === 27) {
      closeMenu();
    }
  }

  render() {
    const { userProfile, navigation, isActive, navBar, closeMenu, controls } = this.props;
    const classes = classNames("sidebar", {
      "sidebar--is-active": isActive,
    });
    return (
      <Fragment>
        {navBar}
        <div className={classes}>
          <button
            type="button"
            tabIndex="-1"
            className="sidebar__overlay"
            aria-label="Close Sidebar"
            onClick={closeMenu}
          />
          <div className="sidebar__inner">
            <div className="sidebar__menu">
              <div className="sidebar__header">{userProfile}</div>
              <div className="sidebar__menu-inner">{navigation}</div>
            </div>
            <ul className="sidebar__controls">
              {controls &&
                controls.map((control, i) => {
                  const { onClick, text, to, icon } = control;

                  if (onClick) {
                    return (
                      <li className="sidebar__controls-item" key={i}>
                        <BaseButton
                          className="vertical-nav__item-btn vertical-nav__item-btn--aside"
                          onClick={onClick}
                        >
                          <span className="vertical-nav__item-btn-inner">
                            {icon && icon({ className: "vertical-nav__item-btn-icon" })}
                            <span className="vertical-nav__item-text">{text}</span>
                          </span>
                        </BaseButton>
                      </li>
                    );
                  }

                  return (
                    <li className="sidebar__controls-item" key={i}>
                      <BaseAnchor
                        className="vertical-nav__item-btn  vertical-nav__item-btn--aside"
                        to={to}
                      >
                        <span className="vertical-nav__item-btn-inner">
                          {icon && icon({ className: "vertical-nav__item-btn-icon" })}
                          <span className="vertical-nav__item-text">{text}</span>
                        </span>
                      </BaseAnchor>
                    </li>
                  );
                })}
            </ul>
          </div>
        </div>
      </Fragment>
    );
  }
}

Sidebar.propTypes = {
  userProfile: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  navigation: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  isActive: PropTypes.bool,
  navBar: PropTypes.node,
  closeMenu: PropTypes.func.isRequired,
  controls: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string.isRequired,
      onClick: PropTypes.func,
      icon: PropTypes.func,
      to: PropTypes.string,
    })
  ),
};

export default Sidebar;
